import apiClient from './apiClient';

export interface ServiceResponse {
    id: string;
    salonId: string;
    name: string;
    description?: string;
    durationMinutes: number;
    price: number;
    category?: string;
    requiredSpecialtyId?: string;
    isActive: boolean;
}

export interface ServiceCreateRequest {
    salonId: string;
    name: string;
    durationMinutes: number;
    price: number;
    requiredSpecialtyId?: string;
}

import type { BulkImportResponse } from './clientApi';

export interface ServiceBulkImportRequest {
    salonId: string;
    services: {
        name: string;
        durationMinutes: number;
        price: number;
    }[];
}

export const serviceApi = {
    getSalonServices: async (salonId: string): Promise<ServiceResponse[]> => {
        const response = await apiClient.get<ServiceResponse[]>(`/services/salon/${salonId}`);
        return response.data;
    },

    getServiceById: async (id: string): Promise<ServiceResponse> => {
        const response = await apiClient.get<ServiceResponse>(`/services/${id}`);
        return response.data;
    },

    createService: async (data: ServiceCreateRequest): Promise<ServiceResponse> => {
        const response = await apiClient.post<ServiceResponse>('/services', data);
        return response.data;
    },

    bulkImport: async (data: ServiceBulkImportRequest): Promise<BulkImportResponse> => {
        const response = await apiClient.post<BulkImportResponse>('/services/bulk', data);
        return response.data;
    },

    updateService: async (id: string, data: Partial<ServiceCreateRequest>): Promise<ServiceResponse> => {
        const response = await apiClient.put<ServiceResponse>(`/services/${id}`, data);
        return response.data;
    },
};
